//components
import {ISimpleTableProps, SimpleTable} from 'thrive-components';


const AccountRecoveryCodes = ({recoveryCodesTableContent} : {recoveryCodesTableContent : ISimpleTableProps}) => {  

    return(
        <div className='account-recovery-codes'>
            <label className='passkey-label'>
                ACCOUNT RECOVERY CODES
            </label>

            <SimpleTable 
                {...recoveryCodesTableContent}
            />  
        </div>
    )
}

export default AccountRecoveryCodes